export const RAVEN_BULK_UPLOAD = 'bulk-upload:';
export const RAVEN_BULK_UPLOAD_PARSE_EXCEL = 'bulk-upload:parse-excel';

export default {};
